// extracted by mini-css-extract-plugin
export default {"container":"cgvZrX7x_KRBL19AxP4H"};